/**
 * Picker Demo Component
 * Demonstrates the Picker component variants and features
 */
import { mdiPalette, mdiTranslate } from "@mdi/js";
import React, { useState } from "react";
import { Typography } from "../typography/Typography";
import { Picker } from "./Picker";
const sortOptions = [
    {
        label: "Recently Listed",
        value: { field: "createdAt", direction: "DESC" },
    },
    {
        label: "Most Endorsed",
        value: { field: "endorsements", direction: "DESC" },
    },
    {
        label: "Highest Rated",
        value: { field: "recentRating", direction: "DESC" },
    },
    {
        label: "Most Downloaded",
        value: { field: "downloads", direction: "DESC" },
    },
];
const colorOptions = [
    { label: "Red", value: "red" },
    { label: "Orange", value: "orange" },
    { label: "Yellow", value: "yellow" },
    { label: "Green", value: "green" },
    { label: "Blue", value: "blue" },
    { label: "Purple", value: "purple" },
];
const languageOptions = [
    { label: "English", value: "en", iconPath: mdiTranslate },
    { label: "French", value: "fr", iconPath: mdiTranslate },
    { label: "German", value: "de", iconPath: mdiTranslate },
    { label: "Spanish", value: "es", iconPath: mdiTranslate },
    { label: "Japanese", value: "ja", iconPath: mdiTranslate },
];
const themeOptions = [
    { label: "Default", value: "default", iconPath: mdiPalette },
    { label: "Dark", value: "dark", iconPath: mdiPalette },
    { label: "Light", value: "light", iconPath: mdiPalette },
    { label: "High Contrast", value: "high-contrast", iconPath: mdiPalette },
];
export const PickerDemo = () => {
    const [color, setColor] = useState("blue");
    const [language, setLanguage] = useState("en");
    const [region, setRegion] = useState("eu");
    const [theme, setTheme] = useState("default");
    const [sortBy, setSortBy] = useState(sortOptions[0].value);
    return (React.createElement("div", { className: "space-y-8" },
        React.createElement("div", { className: "rounded-sm bg-surface-mid p-4" },
            React.createElement(Typography, { as: "h2", typographyType: "heading-sm" }, "Picker"),
            React.createElement(Typography, { appearance: "subdued" }, "Single-value selection built on Headless UI Listbox. Use Picker when the user needs to choose one value from a list, with the selected option shown in the trigger button. Unlike Dropdown which triggers actions, Picker manages selection state.")),
        React.createElement("div", { className: "space-y-4" },
            React.createElement(Typography, { as: "h3", typographyType: "heading-xs" }, "Basic Picker"),
            React.createElement("div", { className: "flex flex-wrap gap-4" },
                React.createElement(Picker, { options: colorOptions, placement: "left", value: color, onChange: setColor }))),
        React.createElement("div", { className: "space-y-4" },
            React.createElement(Typography, { as: "h3", typographyType: "heading-xs" }, "With Icons and Multiple"),
            React.createElement(Typography, { appearance: "subdued", typographyType: "body-sm" }, "Options can include icons via the iconPath prop. Multiple pickers can be used together for related selections."),
            React.createElement("div", { className: "flex flex-wrap gap-4" },
                React.createElement(Picker, { options: themeOptions, placement: "left", value: theme, onChange: setTheme }),
                React.createElement(Picker, { options: languageOptions, placement: "left", value: language, onChange: setLanguage }))),
        React.createElement("div", { className: "space-y-4" },
            React.createElement(Typography, { as: "h3", typographyType: "heading-xs" }, "Object Values"),
            React.createElement(Typography, { appearance: "subdued", typographyType: "body-sm" }, "The value prop is generic and can be any type, including objects. Here each sort option carries both a field name and direction."),
            React.createElement("div", { className: "flex flex-wrap gap-4" },
                React.createElement(Picker, { options: sortOptions, placement: "left", value: sortBy, onChange: setSortBy }))),
        React.createElement("div", { className: "space-y-4" },
            React.createElement(Typography, { as: "h3", typographyType: "heading-xs" }, "Design Notes"),
            React.createElement(Typography, { appearance: "subdued", as: "ul", className: "list-inside list-disc space-y-2" },
                React.createElement("li", null, "The value prop accepts any type via generics \u2014 strings, numbers, or objects"),
                React.createElement("li", null, "Selected option is shown in the trigger button with an unfold chevron"),
                React.createElement("li", null, "A checkmark icon appears next to the currently selected option"),
                React.createElement("li", null, "Options can include icons via the iconPath or icon props")))));
};
